export const CodCatalogo = {
    Departamento: 4,
    Municipio: 5,
    CatalogoAusentismo: 26,
    Sede: 6,
    Escolaridad: 2,
    Genero: 1,
    GrupoLGBT: 247,
    EstadoCivil: 3,
    TipoContrato: 7,
    Rol: 21,
    RosterPosition: 14,
    DescripcionRosterPosition: 248,
    GeneralPosition: 15,
    DepartEmpresa: 13,
    Area: 16,
    SubArea: 17,
    Grupo: 12,
    Turno: 11,
    Estado: 18,
    Eps: 9,
    Afp: 8,
    Arl: 10,
    Ges: 20,
    Cesantias: 19,
    Oficio: 173,
    TIPO_SOLICITUD_DEREPETICION: 28,
    RESPONSABLE_RESPUESTA_DEREPETICION: 112,
    GRUPO_RIESGO: 249,
    PARAMETRO_ESPIRO: 2001,

    /* APT HIGIENE */
    APTPH_CATEGORIA_CARGO: 2035,
    APTPH_AGENTE_BIOLOGICO: 2034,
    APTPH_AGENTE_QUIMICO: 2033,
    APTPH_TIPO_TRABAJO: 2032,
    APTPH_SEDE: 2031,
    APTPH_JORNADATRABAJO: 2030,
    APTPH_CARGAFISICAOWAS: 2029,
    APTHIGIENE_EXIGENCIA_BIOMECANICA: 2036,
    APTHIGIENE_ACTIVIDAD: 2028,
    APTHIGIENE_CATEGORIAPORSEGMENTO: 2027,
    APTHIGIENE_FACTOR_ORGANIZACIONAL: 2026,
    APTHIGIENE_VALOR_REF_SEGMENTO: 2025,

    /* IEL */
    TIPO_RIESGO: 2022,
    IEL_CALIFICACION: 2016,
    IEL_CONTROL: 2017,
    IEL_TIPO_CONTROL: 2018,
    IEL_ASPCONSI: 2019,
    IEL_MOTIVODEVOLUCION: 2020,

    PR_ESTADO_CASO: 2021,
    OPCION_HABITO_INVESTIGACION: 2015,
    VentanillaTipoPeticion: 219,
    VentanillaMedioIngreso: 220,
    VentanillaEmpresaMensajeria: 226,
    VentanillaCondiciones: 221,
    VentanillaNivelImportancia: 222,
    VentanillaArea: 223,
    VentanillaTipoDocumento: 224,
    VentanillaRecibidoPor: 231,

    TipoconceptoApAl: 192,
    EP_EMO_SintomasRespiratorios: 201,

    SoporteTipoCaso: 241,
    SoporteTipoIncidente: 240,
    SoportePrioridad: 239,
    SoporteEstado: 238,

    AtencionEMO: 138,
    Atencion_PARACLINICO: 206,
    Empresas_Paraclinicos: 202,

    CONCEPTO_ESPACIOCONFINADO: 179,
    TIPO_EXAMEN_PARACLINICOS: 68,
    ESTUDIO_EXAMEN_PARACLINICOS: 22,
    LABORATORIO_ORDENES_PARACLINICOS: 30,
    TIPORNM_ORDENES_PARACLINICOS: 114,

    TIPO_ATENCION: 107,

    MEDICINA_LABORAL_INVESTIGACION_EL: 211,
    MEDICINA_LABORAL_ESTADO_ENFERMEDAD_LABORAL: 210,
    MEDICINA_LABORAL_RESULTADO_EN_ORIGEN: 209,
    MEDICINA_LABORAL_PELIGRO_ASOCIADO: 208,
    MEDICINA_LABORAL_ASESOREL: 212,

    PANO_ANALISISRUIDO: 8,
    PANO_ANALISISMPI: 8,
    PANO_EXPOSICIÓN: 130,
    PANO_MEDIDASCONTROL: 40,
    PANO_RIESGO: 128,
    PANO_GRADO_CONSINEPP: 131,

    PARACLINICO_IINTER_COLESTEROL: 205,
    PARACLINICO_INTER_TRIGLICE: 204,

    PARACLINICO_PROTECCIÓNAUDITIVA: 174,
    PARACLINICO_SUMINISTRADOPOR: 175,
    PARACLINICO_USO: 176,
    PARACLINICO_RESULTADOAUDIOGRAMA: 177,
    PARACLINICO_CONDUCTAAUDIOMETRIA: 178,
    PARACLINICO_CONTROLV: 170,

    PARACLINICO_TIPOEPP: 171,
    PARACLINICO_RESULTADO: 172,
    PARACLINICO_LECTURAADD: 169,

    VACUNAS: 154,
    HCO_FRECUENCIAS: 32,
    HCO_REFUERZO: 150,
    HC_DEPORTE: 143,
    HC_TIFOBIA: 39,
    HCO_PARENTES: 123,
    HCO_GINECOMETO: 180,
    HCO_GINECOCICLO: 124,
    HCO_GINECORESULT: 8,
    HCO_BIOTIPO: 37,
    HCO_RESULTADO: 140,
    HCO_CONCEP_APTI_PSICO_INGRESO: 151,
    HCO_CONCEP_APTI_PSICO_CONTROL: 152,
    /* HCO_CONCEP_APTI_PSICO_PROMO: 153, */
    HCO_CONCEPTO_APTI_MEDICA: 42,
    OPT_SINO: 8,
    HCO_NEADONDE: 145,
    HCO_RIESGO_CLASIFICACION: 127,
    HCO_SINTOMAS_RESPIRATORIO: 146,

    HCO_DX_TENSION_ARTERIAL: 110,
    HCO_ANTECEDENTE_CARDIOVASCULAR: 111,
    HCO_FRAM_BEBIDAS: 31,
    HCO_DX_METABOLICO: 142,

    RECE_TIPORDEN: 73,
    RECE_CONTINGENCIA: 74,

    PAD_MOTIVO: 50,
    PAD_MOTIVO_NO_ASIS: 54,

    UNIDAD: 36,
    LABORATORIO: 245,

    PAD_MUESTRA_AD: 115,
    PAD_MUESTRA_AL: 117,
    PAD_RESULTADO: 116,
    PAD_CONCEPTOA: 147,

    ASME_TIPOASESORIA: 119,

    TIPO_PROVEEDOR: 22,
    ROL_USUARIO: 157,
    ESPECIALIDAD_MEDICO: 158,
    CIUDADES: 5,

    ALIENTOALCOHOLICO: 2013,
    ESTADOCONCIENCIA: 2012,
    ATENCION: 2011,
    FLUJOLENGUAJE: 2010,
    DISARTRIA: 2009,
    PUPILA: 2008,
    OTRASOPCIONES: 2007,
    REFLEJOSOSTEOTENDINOSOS: 2006,
    OPCIONESAUSENTEPRESENTE: 2005,
    CUANDOPOSITIVO: 2004,
    DETERMINACION: 2003,

    CLASE_AT: 98,
    CAUSA_AT: 99,
    SUBTIPO_AT: 100,
    ESTADO_AT: 102,

    AHC_ATENCION_NOTA_ENFERMERIA: 136,
    Contingencia: 74,
    TipoTransporte: 244, /* 243 LOCAL 244 SERVIDOR */
    PROCEDIMIENTO_ENFERMERIA: 156,
    DiaTurno: 76,
    JornadaTurno: 139,
    MotivoPsicologia: 53,
    MotivoMedica: 52,

    ESTADO_EMPLEADO: 162,
    ESTADO_RESTRICCION: 163,
    TIPO_RESTRICCION: 164,
    ORDENADO_POR: 94,
    CONCEPTO_APTITUD_REINTEGRO: 95,
    ORDENADO_POR_HORARIO: 167,
    ORIGEN_REINTEGRO: 90,

    CausaAsesoria: 120,
    EstadoAsesoria: 8,
    EstadoCaso: 48,
    ESTADO_CASO: 38,
    TipoAtencion: 65,
    SaludOcupacional_Atencion: 8,
    SaludOcupacional_Motivo: 8,
    TipoAtencion_Item: 8,

    ORIGEN_RUTA: 34,
    DESTINO_RUTA: 35,
    NRO_TAXI: 194,
    CARGADO_A: 195,
    CUPOS: 196,

    AHC_ATENCION: 135,
    Opciones_SINO: 88,
    AHC_CONCEP_ACTITUD: 43,

    AUSLAB_INC: 198,
    AUSLAB_TIPOINCA: 103,
    AUSLAB_CONT: 104,
    AUSLAB_ESTCAS: 200,
    AUSLAB_TISOPOR: 27,
    AUSLAB_CATEGORIA: 8,
    AUSLAB_TIPOATEN: 199,
    AUSLAB_REDEXP: 108,

    MEDLAB_SALACALIFICADORA: 218,
    MEDLAB_RECASO: 38,
    MEDLAB_INVESTIGADOPOR: 237,
    MEDLAB_ENTIDADINFORMA: 243,
    MEDLAB_REGION: 81,
    MEDLAB_LATERA: 82,
    MEDLAB_ENMO_EN: 83,
    MEDLAB_ENDON_EN: 84,
    MEDLAB_ORIGEN_EPS: 87,
    MEDLAB_ORI_CA_ARL: 87,
    MEDLAB_INS_ORIGEN: 197,

    LISTA_CHEKEO_REINTEGRO: 159,
    TODAS_ASESORIAS: 137,
    LATERALIDAD: 82,
    SITUACION_EMPLEADO: 214,
    VISTO_BUENO: 215,


    /*  APTCalificacion */
    APTPSICO_FUENTES: 2040,
    APTPSICO_PARENTESCO: 2041,

    APT_GRUPO_CONDICION: 16,
    APT_CONDICION: 16,
    APT_EXPOSICION: 16,
    APT_FRECUENCIA: 16,
    APT_INTENSIDAD: 16,
    APT_TIPO: 16,
    APT_CARGO: 16,
    APT_AREA: 16,
    APT_PUESTO_TRABAJO: 16,

}

export const DefaultData = {
    SINREGISTRO_GLOBAL: 1,
    AsesoriaPsicologica: 3909,
    ASESORIA_MEDICA: 3911,
    SinRegistro: 1,
    EmpresaDrummond: 1401,
}

export const IdUser = {
    fcardenas: 9,
}

export const AccionMenu = {
    agregar: 1,
    actualizar: 2,
    eliminar: 3
}

export const Modulo = {
    Empleado: 1,
    Atencion: 2,
    Asesoriamedica: 3,
    Asesoriapsicologica: 4,
    Otrasasesorias: 5,
    Accidentedetrabajo: 6,
    Reintegro: 7,
    Medicinalaboral: 8,
    Ausentismolaboral: 9,
    Ordenesindividuales: 10,
    Detalleordenes: 11,
    Audiometria: 12,
    Electrocardiograma: 13,
    Espirometria: 14,
    Laboratorio: 15,
    Rxtorax: 16,
    Visiometria: 17,
    RNM: 18,
    PSA: 19,
    Citologia: 20,
    Programaciondeordenes: 21,
    Indexacion: 22,
    Recetario: 23,
    Pruebadealcoholydroga: 24,
    Solicituddetaxi: 25,
    OrdenesEPP: 26,
    Conceptodeaptitud: 27,
    Framingham: 28,
    CorrespondenciaSolicitud: 29,
    SGSST: 30,
    ProductosMedicamento: 31,
    Pedidos: 32,
    Entrega: 33,
    Tipodecatalogo: 34,
    Catalogo: 35,
    Empresa: 36,
    Proveedor: 37,
    CIE10: 38,
    Plantilla: 39,
    Apuntespernales: 40,
    HeadCount: 41,
    Apuntesdeindexacion: 42,
    Productos: 43,
    Panoramadecargo: 44,
    Usuario: 45,
    Rol: 46,
    AsignacionInvestigacion: 47,
    InvestigacionEnfermedadLaboral: 48,
    APTCalificacion: 49,
}

export const IdTipoProveedor = {
    Espirometria: 3536
}

export const DefaultValue = {
    SINREGISTRO_GLOBAL: 1,
    GeneroPersonalizado: 10193,
    TIPO_TRANSPORTE_OTRO: 10159,
    BANDERA_DRUMMOND: 7116,
    SINREGISTRO_TEXTO: 'REGISTRO NO APLICA',
    GeneroWomen: 2,
    PROVEEDOR_MEDICAMENTO: 3539,
    OrdenadoPor_Reintegro_MedicoDLTD: 5180,

    ATENCION_ATENDIDO: 'ATENDIDO',
    ATENCION_ESTASIENDOATENDIDO: 'ESTÁ SIENDO ATENDIDO',
    ATENCION_PENDIENTE_ATENDIDO: 'PENDIENTE POR ATENCIÓN',

    /* TIPO DE PARACLINICO */
    PARACLINICO_RNM: 'RNM',
    PARACLINICO_ELECTRO: 'ELECTROCARDIOGRAMA',
    PARACLINICO_PSA: 'PSA',
    PARACLINICO_RXTORAX: 'RXTORAX',
    PARACLINICO_CITOLOGIA: 'CITOLOGIA',
    PARACLINICO_VISIOMETRIA: 'VISIOMETRIA',
    PARACLINICO_ESPIROMETRIA: 'ESPIROMETRIA',
    PARACLINICO_AUDIOMETRIA: 'AUDIOMETRIA',
    PARACLINICO_LABORATORIO: 'LABORATORIO',

    /* TIPO DE ORDEN */
    TIPO_ORDEN_FORMULA: 4023,
    TIPO_ORDEN_EXAMEN: 4026,
    TIPO_ORDEN_IMAGEN: 4025,
    TIPO_ORDEN_LABORATORIO: 4024,

    TIPO_EXAMEN_CONTROLPERIODICO: 4109,
    TIPO_EXAMEN_INGRESO: 4112,

    /* TIPO ATENCIÓN */
    TIPO_ATENCION_EMO: 3900,
    ATENCION_PRUEBA_ALCOHOL: 3908,
    ATENCION_HISTORIA_EMBRIAGUEZ: 11128, /* Cambiar o revisar */
    ATENCION_ENFERMERIA: 3907,
    TIPO_ATENCION_ASESORIAS: 3899,
    TIPO_ATENCION_ASESORIAS_PSICO: 3909,
    TIPO_ATENCION_ASESORIAS_MEDICA: 3911,
    TIPO_ATENCION_ENFERMERIA: 3898,
    TIPO_ATENCION_ATENCIONMEDICA: 3897,
    TIPO_ATENCION_ATENCIONMEDICA_NUEVO: 3931,
    TIPO_ATENCION_ATENCIONMEDICA_CONTROL: 3932,

    /* ATENCIÓN EMO */
    EMO_ATENCION_INGRESO: 3918,
    EMO_ATENCION_CONTRO: 3921,
    EMO_ATENCION_PROMO: 3922,
    EMO_ATENCION_EGRESO: 3919,
    EMO_ATENCION_REINCORPORACION: 3920,

    ORDENES_LABORATORIO: 3533,
    ORDENES_FECHA_EXAM_FISICO: 3541,
    ORDENES_RNM: 3537,

    CONCEPTO_PAD_APTO: 4103,
    CONCEPTO_PAD_NOAPTO: 4104,
    RESULTADO_PAD_POSITIVO: 4097,

    /* REGISTRO ATENCIÓN */
    TIP_AT_TRIAGE: 3897,
    TIP_AT_ENFERME: 3898,
    TIP_AT_ASESORIA: 3899,
    TIP_AT_EMO: 3900,
    AT_ENFERMERIA: 3907,
    AT_PAD: 3908,
    PAD_MOTIVO_SOSPECHA: 3802,

    AT_PSICO: 3909,

    VIDEO_LLAMADA: 7319,

    /* POR DEFECTO EN AUSENTISMO LABORAL */
    INCAPACIDAD_MEDICA: 8171,
    INCAPACIDAD_ANTIGUO: 8178,
    INCAPACIDAD_HOSPITALIZACION: 8181,
    INCAPACIDAD_EPS: 8184,

    /* ID ROLES DE USUARIO */
    ROL_MEDICO: 4,
    ROL_PSICOLOGIA: 8,

    /* RIESGOS */
    RiesgoEnOtrasEmpresas: 7284,
    RiesgoEnDLTD: 7403,
    RiesgoQuimico: 3949,
    RiesgoQuimico_MPI_DLTD: 3955,
    RiesgoQuimico_RUIDO_DLTD: 3960,
    RiesgoFisico: 3950,
    RiesgoPsicosocial: 3952,
    RiesgoBiologico: 3953,
    RiesgoErgonomicoCargaFisica_Postura: 3954,
    RiesgoErgonomicoCargaFisica_Fuerza: 4065,
    RiesgoErgonomicoCargaFisica_Movimiento: 4066,

    /* OPCIONES DE SI NO */
    Opcion_SI: 4005,
    Opcion_NO: 4006,

    /* SEDE */
    SEDE_PUERTO: 1106,

    /* TRIAGES */
    TRIAGE_I: 3901,
    TRIAGE_II: 3902,
    TRIAGE_III: 3903,
    TRIAGE_VI: 3904,
    TRIAGE_V: 3905,
}

export const TitleButton = {
    Guardar: 'Guardar',
    CambiarContrasenia: 'Cambiar contraseña',
    CerrarCaso: 'Cerrar Caso',
    OrdenesMedicas: 'Ordenes medicas',
    SubirArchivo: 'Subir archivo',
    Programacion: 'Programación',
    Imprimir: 'Imprimir',
    Descargar: 'Descargar',
    Cancelar: 'Cerrar',
    Limpiar: 'Limpiar',
    VerArchivo: 'Ver archivo',
    Cerrar: 'Cancelar',
    Actualizar: 'Actualizar',
    Eliminar: 'Eliminar',
    Agregar: 'Nuevo',
    Filter: 'Filtrar',
    Seleccionadas: 'Seleccionadas',
    Regresar: 'Regresar',
    RegresarACargos: 'Regresar a cargos',
    EnviarCorreo: 'Enviar',
    AgregarOrden: 'Agregar',
    Editar: 'Editar',
    Historico: 'Historico',
    GenerarExcel: 'Generar excel',
    DescargarExcel: 'Descargar excel',
    Excel: "Generar y descargar excel"
}

export const ValidationMessage = {
    Requerido: 'Por favor ingrese la descripción',
}

export const Message = {
    Guardar: 'Registro guardado con éxito',
    Actualizar: 'Registro actualizado con éxito',
    Eliminar: 'Registro eliminado con éxito',

    NoRegistro: 'No hay registros',
    NoExiste: 'Este registro no existe',

    RiesgoGuardado: 'Riesgos Cargados',
    TituloEliminar: '¿Estas seguro?',
    TextoEliminar: 'Este registro se eliminara, ¿esta seguro de eliminarlo?',

    TituloCerrarCaso: '¿Estas seguro de Cerrar Caso?',
    TextoCerrarCaso: 'Este caso será cerrado, ¿esta seguro de hacerlo?',

    TituloCargar: '¿Desea cargar la exposición ocupacional?',
    TextoCargar: 'Se cargaran los riesgos, esto puede demorar un poco',

    TituloOrdenes: '¿Esta seguro de guardar las ordenes?',
    TextoAgregarOrdenes: 'Luego de guardar no podra agregar otro empleado ni paraclinico',

    NoEliminar: 'No se pudo eliminar el registro',
    RegistroNoGuardado: 'No se pudo guardar el registro',
    RegistroNoEliminado: 'No se pudo eliminar el registro',

    NoExisteDocumento: 'Este empleado no existe',
    ErrorDocumento: 'Por favor, ingrese un número de documento',

    ErrorDeDatos: 'Hubo un error al buscar los datos, vuelva a intentarlo',
    ErrorNoHayDatos: 'No hay datos buscados, vuelva a intentarlo',

    CampoRequerido: 'Este campo es requerido',
    CorreoNoEnviado: 'No se pudo enviar el correo',
    ExcelNoGenerado: 'No se pudo generar el excel',
    SinCorreo: 'Este empleado no tiene correo registrado',
    VistaReporte: 'Vista de reporte',
    VistaArchivo: 'Vista De Archivo',
    ErrorExcel: 'Error: No se pudo generar el Excel',
}

export const optionsDate = {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
};

export const CodRegistroAtencion = {
    Emo: 'EMO',
    Asesoria: 'ASESORIA',
    HistoriaClinica: 'HC',
    NotaEnfermeria: 'NENF',
    NotaEvolucion: 'NEVO',
    PruebaAlcoholDroga: 'PAD'
}

export const ArrayRisk = [
    { value: 1, label: "Químicos".toUpperCase() },
    { value: 2, label: "Físicos".toUpperCase() },
    { value: 3, label: "Biológicos".toUpperCase() },
    { value: 4, label: "Psicosocial".toUpperCase() },
    { value: 5, label: "Carga física dinámica".toUpperCase() },
    { value: 6, label: "Carga física estática".toUpperCase() }
]